import FJCoverImage from '../../../../common/components/FJCoverImage/FJCoverImage';
import FJCoverVideo from '../../../../common/components/FJCoverVideo/FJCoverVideo';
import FJConstant from '../../../../constants/FJConstant';
import styles from './FJCommunityMedia.module.less';
import PropTypes from 'prop-types';

const FJCommunityMedia = props => {
    const { mediaType, coverVideo, coverImg, videoUrl, imgUrl, children, autoPlay = false } = props;
    if (mediaType === FJConstant.VIDEO) {
        return (
            <FJCoverVideo
                videoSrc={videoUrl}
                videoClassName={styles.media}
                boxClassName={styles.media_box}
                coverImage={imgUrl}
                coverVideo={coverVideo}
                autoPlay={autoPlay}
                addRefreshEvent={true}
            >
                {children}
            </FJCoverVideo>
        );
    }
    return (
        <FJCoverImage
            coverImg={coverImg}
            imgSrc={imgUrl}
            boxClassName={styles.media_box}
            isShowLoading={true}
            imgClassName={styles.media}
            addRefreshEvent={true}
        >
            {children}
        </FJCoverImage>
    );
};
FJCommunityMedia.propTypes = {
    mediaType: PropTypes.string,
    coverVideo: PropTypes.string,
    coverImg: PropTypes.string,
    videoUrl: PropTypes.string,
    imgUrl: PropTypes.string,
    children: PropTypes.node,
    autoPlay: PropTypes.bool,
};
export default FJCommunityMedia;
